"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6443],{

/***/ 6443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ glomil_organization_chart_GlomilOrganizationChart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./components/base/image/index.tsx + 1 modules
var base_image = __webpack_require__(5244);
// EXTERNAL MODULE: ./components/base/icon/Icon.tsx
var Icon = __webpack_require__(6653);
// EXTERNAL MODULE: ./components/base/anchor/Anchor.tsx
var Anchor = __webpack_require__(3357);
;// CONCATENATED MODULE: ./components/widgets/glomil-organization-chart/GlomilOrganizationChart.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var GlomilOrganizationChart = function(param) {
    var _data = param.data, data1 = _data === void 0 ? [] : _data;
    var getGrouppedManagers = function(parent) {
        var group = [];
        var mapping = function(data) {
            return {
                name: data.name,
                surname: data.surname,
                image: data.image,
                depertmant: data.depertmant,
                order: data.order,
                sector: data.sector ? data.sector : '',
                children: getGrouppedManagers(data),
                linkedin: data.linkedin
            };
        };
        if (parent) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = data1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var manager = _step.value;
                    var isChildren = manager.parentId === parent.id;
                    if (isChildren) {
                        if (!parent.sector) {
                            group.push(mapping(manager));
                        } else {
                            group.push(mapping(_objectSpread({}, manager))) // sector: undefined
                            ;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            var rootManager = data1.find(function(item) {
                return !item.sector;
            });
            if (rootManager) {
                group.push(mapping(rootManager));
            }
        }
        return group;
    };
    var renderEmployee = function(manager1) {
        var ref2, ref1;
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "organization-items-item-detail",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base_image["default"], _objectSpread({}, manager1.image, {
                            alt: manager1.name
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "organization-items-item-detail-desc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "organization-items-item-detail-desc-title",
                                            children: [
                                                manager1.name,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: manager1.surname
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "organization-items-item-detail-desc-department",
                                            children: manager1.depertmant
                                        })
                                    ]
                                }),
                                manager1.linkedin && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "social-media",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                        href: (ref2 = manager1.linkedin) === null || ref2 === void 0 ? void 0 : ref2.href,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: "icon-linkedin1"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                ((ref1 = manager1.children) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "organization-items",
                    children: (manager1.children || []).sort(function(a, b) {
                        return a.order - b.order;
                    }).map(function(manager) {
                        var ref;
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,functions.classnames)('organization-items-item', manager.sector && 'has-sector', ((ref = manager.children) === null || ref === void 0 ? void 0 : ref.length) && 'has-manager'),
                            children: [
                                manager.sector && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "organization-items-sector-title",
                                    children: manager.sector
                                }),
                                renderEmployee(manager)
                            ]
                        }, manager.name));
                    })
                }) : null
            ]
        }));
    };
    var renderManagers = function() {
        var managers = getGrouppedManagers();
        return managers.map(function(manager, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "organization-items-item",
                children: renderEmployee(manager)
            }, index);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "organization-items",
        children: renderManagers()
    }));
};
/* harmony default export */ var glomil_organization_chart_GlomilOrganizationChart = (GlomilOrganizationChart);

;// CONCATENATED MODULE: ./components/widgets/glomil-organization-chart/index.ts



/***/ })

}]);